import { apiClient } from "./api-client"
import { demoCurrentTenant } from "@/data/demo-data"
import type { DirectorTenant } from "@/types/director"

const BASE_PATH = "/ReportManagement"
const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true"

export const directorApi = {
  async getCurrentTenant(): Promise<DirectorTenant> {
    if (isDemoMode) {
      return demoCurrentTenant
    }
    return apiClient.get(`${BASE_PATH}/CurrentTenant`)
  },
}
